/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MobileIndexRouteImport } from './routes/mobile/index'
import { Route as DesktopIndexRouteImport } from './routes/desktop/index'
import { Route as Mobile_baseLayoutRouteImport } from './routes/mobile/__base-layout'
import { Route as Desktop_appRouteImport } from './routes/desktop/__app'
import { Route as MobileProfileIndexRouteImport } from './routes/mobile/profile/index'
import { Route as MobileHomeIndexRouteImport } from './routes/mobile/home/index'
import { Route as MobileGameIndexRouteImport } from './routes/mobile/game/index'
import { Route as MobileBuyCardsIndexRouteImport } from './routes/mobile/buy-cards/index'
import { Route as Mobile_baseLayoutWithdrawIndexRouteImport } from './routes/mobile/__base-layout/withdraw/index'
import { Route as Mobile_baseLayoutPoliciesIndexRouteImport } from './routes/mobile/__base-layout/policies/index'
import { Route as Mobile_baseLayoutExtractionsIndexRouteImport } from './routes/mobile/__base-layout/extractions/index'
import { Route as Mobile_baseLayoutCardsIndexRouteImport } from './routes/mobile/__base-layout/cards/index'
import { Route as Desktop_appWithdrawIndexRouteImport } from './routes/desktop/__app/withdraw/index'
import { Route as Desktop_appPoliciesIndexRouteImport } from './routes/desktop/__app/policies/index'
import { Route as Desktop_appMyCardsIndexRouteImport } from './routes/desktop/__app/my-cards/index'
import { Route as Desktop_appHowToPlayIndexRouteImport } from './routes/desktop/__app/how-to-play/index'
import { Route as Desktop_appHomeIndexRouteImport } from './routes/desktop/__app/home/index'
import { Route as Desktop_appGameIndexRouteImport } from './routes/desktop/__app/game/index'
import { Route as Desktop_appBuyIndexRouteImport } from './routes/desktop/__app/buy/index'
import { Route as Mobile_baseLayoutCardCardIdIndexRouteImport } from './routes/mobile/__base-layout/card/$cardId/index'
import { Route as Desktop_appMyCardsCardIndexRouteImport } from './routes/desktop/__app/my-cards/$card/index'

const MobileRouteImport = createFileRoute('/mobile')()
const DesktopRouteImport = createFileRoute('/desktop')()

const MobileRoute = MobileRouteImport.update({
  id: '/mobile',
  path: '/mobile',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopRoute = DesktopRouteImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileIndexRoute = MobileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MobileRoute,
} as any)
const DesktopIndexRoute = DesktopIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DesktopRoute,
} as any)
const Mobile_baseLayoutRoute = Mobile_baseLayoutRouteImport.update({
  id: '/__base-layout',
  getParentRoute: () => MobileRoute,
} as any)
const Desktop_appRoute = Desktop_appRouteImport.update({
  id: '/__app',
  getParentRoute: () => DesktopRoute,
} as any)
const MobileProfileIndexRoute = MobileProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => MobileRoute,
} as any)
const MobileHomeIndexRoute = MobileHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => MobileRoute,
} as any)
const MobileGameIndexRoute = MobileGameIndexRouteImport.update({
  id: '/game/',
  path: '/game/',
  getParentRoute: () => MobileRoute,
} as any)
const MobileBuyCardsIndexRoute = MobileBuyCardsIndexRouteImport.update({
  id: '/buy-cards/',
  path: '/buy-cards/',
  getParentRoute: () => MobileRoute,
} as any)
const Mobile_baseLayoutWithdrawIndexRoute =
  Mobile_baseLayoutWithdrawIndexRouteImport.update({
    id: '/withdraw/',
    path: '/withdraw/',
    getParentRoute: () => Mobile_baseLayoutRoute,
  } as any)
const Mobile_baseLayoutPoliciesIndexRoute =
  Mobile_baseLayoutPoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => Mobile_baseLayoutRoute,
  } as any)
const Mobile_baseLayoutExtractionsIndexRoute =
  Mobile_baseLayoutExtractionsIndexRouteImport.update({
    id: '/extractions/',
    path: '/extractions/',
    getParentRoute: () => Mobile_baseLayoutRoute,
  } as any)
const Mobile_baseLayoutCardsIndexRoute =
  Mobile_baseLayoutCardsIndexRouteImport.update({
    id: '/cards/',
    path: '/cards/',
    getParentRoute: () => Mobile_baseLayoutRoute,
  } as any)
const Desktop_appWithdrawIndexRoute =
  Desktop_appWithdrawIndexRouteImport.update({
    id: '/withdraw/',
    path: '/withdraw/',
    getParentRoute: () => Desktop_appRoute,
  } as any)
const Desktop_appPoliciesIndexRoute =
  Desktop_appPoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => Desktop_appRoute,
  } as any)
const Desktop_appMyCardsIndexRoute = Desktop_appMyCardsIndexRouteImport.update({
  id: '/my-cards/',
  path: '/my-cards/',
  getParentRoute: () => Desktop_appRoute,
} as any)
const Desktop_appHowToPlayIndexRoute =
  Desktop_appHowToPlayIndexRouteImport.update({
    id: '/how-to-play/',
    path: '/how-to-play/',
    getParentRoute: () => Desktop_appRoute,
  } as any)
const Desktop_appHomeIndexRoute = Desktop_appHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => Desktop_appRoute,
} as any)
const Desktop_appGameIndexRoute = Desktop_appGameIndexRouteImport.update({
  id: '/game/',
  path: '/game/',
  getParentRoute: () => Desktop_appRoute,
} as any)
const Desktop_appBuyIndexRoute = Desktop_appBuyIndexRouteImport.update({
  id: '/buy/',
  path: '/buy/',
  getParentRoute: () => Desktop_appRoute,
} as any)
const Mobile_baseLayoutCardCardIdIndexRoute =
  Mobile_baseLayoutCardCardIdIndexRouteImport.update({
    id: '/card/$cardId/',
    path: '/card/$cardId/',
    getParentRoute: () => Mobile_baseLayoutRoute,
  } as any)
const Desktop_appMyCardsCardIndexRoute =
  Desktop_appMyCardsCardIndexRouteImport.update({
    id: '/my-cards/$card/',
    path: '/my-cards/$card/',
    getParentRoute: () => Desktop_appRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/desktop': typeof Desktop_appRouteWithChildren
  '/mobile': typeof Mobile_baseLayoutRouteWithChildren
  '/desktop/': typeof DesktopIndexRoute
  '/mobile/': typeof MobileIndexRoute
  '/mobile/buy-cards': typeof MobileBuyCardsIndexRoute
  '/mobile/game': typeof MobileGameIndexRoute
  '/mobile/home': typeof MobileHomeIndexRoute
  '/mobile/profile': typeof MobileProfileIndexRoute
  '/desktop/buy': typeof Desktop_appBuyIndexRoute
  '/desktop/game': typeof Desktop_appGameIndexRoute
  '/desktop/home': typeof Desktop_appHomeIndexRoute
  '/desktop/how-to-play': typeof Desktop_appHowToPlayIndexRoute
  '/desktop/my-cards': typeof Desktop_appMyCardsIndexRoute
  '/desktop/policies': typeof Desktop_appPoliciesIndexRoute
  '/desktop/withdraw': typeof Desktop_appWithdrawIndexRoute
  '/mobile/cards': typeof Mobile_baseLayoutCardsIndexRoute
  '/mobile/extractions': typeof Mobile_baseLayoutExtractionsIndexRoute
  '/mobile/policies': typeof Mobile_baseLayoutPoliciesIndexRoute
  '/mobile/withdraw': typeof Mobile_baseLayoutWithdrawIndexRoute
  '/desktop/my-cards/$card': typeof Desktop_appMyCardsCardIndexRoute
  '/mobile/card/$cardId': typeof Mobile_baseLayoutCardCardIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/desktop': typeof DesktopIndexRoute
  '/mobile': typeof MobileIndexRoute
  '/mobile/buy-cards': typeof MobileBuyCardsIndexRoute
  '/mobile/game': typeof MobileGameIndexRoute
  '/mobile/home': typeof MobileHomeIndexRoute
  '/mobile/profile': typeof MobileProfileIndexRoute
  '/desktop/buy': typeof Desktop_appBuyIndexRoute
  '/desktop/game': typeof Desktop_appGameIndexRoute
  '/desktop/home': typeof Desktop_appHomeIndexRoute
  '/desktop/how-to-play': typeof Desktop_appHowToPlayIndexRoute
  '/desktop/my-cards': typeof Desktop_appMyCardsIndexRoute
  '/desktop/policies': typeof Desktop_appPoliciesIndexRoute
  '/desktop/withdraw': typeof Desktop_appWithdrawIndexRoute
  '/mobile/cards': typeof Mobile_baseLayoutCardsIndexRoute
  '/mobile/extractions': typeof Mobile_baseLayoutExtractionsIndexRoute
  '/mobile/policies': typeof Mobile_baseLayoutPoliciesIndexRoute
  '/mobile/withdraw': typeof Mobile_baseLayoutWithdrawIndexRoute
  '/desktop/my-cards/$card': typeof Desktop_appMyCardsCardIndexRoute
  '/mobile/card/$cardId': typeof Mobile_baseLayoutCardCardIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/desktop': typeof DesktopRouteWithChildren
  '/desktop/__app': typeof Desktop_appRouteWithChildren
  '/mobile': typeof MobileRouteWithChildren
  '/mobile/__base-layout': typeof Mobile_baseLayoutRouteWithChildren
  '/desktop/': typeof DesktopIndexRoute
  '/mobile/': typeof MobileIndexRoute
  '/mobile/buy-cards/': typeof MobileBuyCardsIndexRoute
  '/mobile/game/': typeof MobileGameIndexRoute
  '/mobile/home/': typeof MobileHomeIndexRoute
  '/mobile/profile/': typeof MobileProfileIndexRoute
  '/desktop/__app/buy/': typeof Desktop_appBuyIndexRoute
  '/desktop/__app/game/': typeof Desktop_appGameIndexRoute
  '/desktop/__app/home/': typeof Desktop_appHomeIndexRoute
  '/desktop/__app/how-to-play/': typeof Desktop_appHowToPlayIndexRoute
  '/desktop/__app/my-cards/': typeof Desktop_appMyCardsIndexRoute
  '/desktop/__app/policies/': typeof Desktop_appPoliciesIndexRoute
  '/desktop/__app/withdraw/': typeof Desktop_appWithdrawIndexRoute
  '/mobile/__base-layout/cards/': typeof Mobile_baseLayoutCardsIndexRoute
  '/mobile/__base-layout/extractions/': typeof Mobile_baseLayoutExtractionsIndexRoute
  '/mobile/__base-layout/policies/': typeof Mobile_baseLayoutPoliciesIndexRoute
  '/mobile/__base-layout/withdraw/': typeof Mobile_baseLayoutWithdrawIndexRoute
  '/desktop/__app/my-cards/$card/': typeof Desktop_appMyCardsCardIndexRoute
  '/mobile/__base-layout/card/$cardId/': typeof Mobile_baseLayoutCardCardIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/desktop'
    | '/mobile'
    | '/desktop/'
    | '/mobile/'
    | '/mobile/buy-cards'
    | '/mobile/game'
    | '/mobile/home'
    | '/mobile/profile'
    | '/desktop/buy'
    | '/desktop/game'
    | '/desktop/home'
    | '/desktop/how-to-play'
    | '/desktop/my-cards'
    | '/desktop/policies'
    | '/desktop/withdraw'
    | '/mobile/cards'
    | '/mobile/extractions'
    | '/mobile/policies'
    | '/mobile/withdraw'
    | '/desktop/my-cards/$card'
    | '/mobile/card/$cardId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/desktop'
    | '/mobile'
    | '/mobile/buy-cards'
    | '/mobile/game'
    | '/mobile/home'
    | '/mobile/profile'
    | '/desktop/buy'
    | '/desktop/game'
    | '/desktop/home'
    | '/desktop/how-to-play'
    | '/desktop/my-cards'
    | '/desktop/policies'
    | '/desktop/withdraw'
    | '/mobile/cards'
    | '/mobile/extractions'
    | '/mobile/policies'
    | '/mobile/withdraw'
    | '/desktop/my-cards/$card'
    | '/mobile/card/$cardId'
  id:
    | '__root__'
    | '/'
    | '/desktop'
    | '/desktop/__app'
    | '/mobile'
    | '/mobile/__base-layout'
    | '/desktop/'
    | '/mobile/'
    | '/mobile/buy-cards/'
    | '/mobile/game/'
    | '/mobile/home/'
    | '/mobile/profile/'
    | '/desktop/__app/buy/'
    | '/desktop/__app/game/'
    | '/desktop/__app/home/'
    | '/desktop/__app/how-to-play/'
    | '/desktop/__app/my-cards/'
    | '/desktop/__app/policies/'
    | '/desktop/__app/withdraw/'
    | '/mobile/__base-layout/cards/'
    | '/mobile/__base-layout/extractions/'
    | '/mobile/__base-layout/policies/'
    | '/mobile/__base-layout/withdraw/'
    | '/desktop/__app/my-cards/$card/'
    | '/mobile/__base-layout/card/$cardId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DesktopRoute: typeof DesktopRouteWithChildren
  MobileRoute: typeof MobileRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mobile': {
      id: '/mobile'
      path: '/mobile'
      fullPath: '/mobile'
      preLoaderRoute: typeof MobileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop': {
      id: '/desktop'
      path: '/desktop'
      fullPath: '/desktop'
      preLoaderRoute: typeof DesktopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/': {
      id: '/mobile/'
      path: '/'
      fullPath: '/mobile/'
      preLoaderRoute: typeof MobileIndexRouteImport
      parentRoute: typeof MobileRoute
    }
    '/desktop/': {
      id: '/desktop/'
      path: '/'
      fullPath: '/desktop/'
      preLoaderRoute: typeof DesktopIndexRouteImport
      parentRoute: typeof DesktopRoute
    }
    '/mobile/__base-layout': {
      id: '/mobile/__base-layout'
      path: '/mobile'
      fullPath: '/mobile'
      preLoaderRoute: typeof Mobile_baseLayoutRouteImport
      parentRoute: typeof MobileRoute
    }
    '/desktop/__app': {
      id: '/desktop/__app'
      path: '/desktop'
      fullPath: '/desktop'
      preLoaderRoute: typeof Desktop_appRouteImport
      parentRoute: typeof DesktopRoute
    }
    '/mobile/profile/': {
      id: '/mobile/profile/'
      path: '/profile'
      fullPath: '/mobile/profile'
      preLoaderRoute: typeof MobileProfileIndexRouteImport
      parentRoute: typeof MobileRoute
    }
    '/mobile/home/': {
      id: '/mobile/home/'
      path: '/home'
      fullPath: '/mobile/home'
      preLoaderRoute: typeof MobileHomeIndexRouteImport
      parentRoute: typeof MobileRoute
    }
    '/mobile/game/': {
      id: '/mobile/game/'
      path: '/game'
      fullPath: '/mobile/game'
      preLoaderRoute: typeof MobileGameIndexRouteImport
      parentRoute: typeof MobileRoute
    }
    '/mobile/buy-cards/': {
      id: '/mobile/buy-cards/'
      path: '/buy-cards'
      fullPath: '/mobile/buy-cards'
      preLoaderRoute: typeof MobileBuyCardsIndexRouteImport
      parentRoute: typeof MobileRoute
    }
    '/mobile/__base-layout/withdraw/': {
      id: '/mobile/__base-layout/withdraw/'
      path: '/withdraw'
      fullPath: '/mobile/withdraw'
      preLoaderRoute: typeof Mobile_baseLayoutWithdrawIndexRouteImport
      parentRoute: typeof Mobile_baseLayoutRoute
    }
    '/mobile/__base-layout/policies/': {
      id: '/mobile/__base-layout/policies/'
      path: '/policies'
      fullPath: '/mobile/policies'
      preLoaderRoute: typeof Mobile_baseLayoutPoliciesIndexRouteImport
      parentRoute: typeof Mobile_baseLayoutRoute
    }
    '/mobile/__base-layout/extractions/': {
      id: '/mobile/__base-layout/extractions/'
      path: '/extractions'
      fullPath: '/mobile/extractions'
      preLoaderRoute: typeof Mobile_baseLayoutExtractionsIndexRouteImport
      parentRoute: typeof Mobile_baseLayoutRoute
    }
    '/mobile/__base-layout/cards/': {
      id: '/mobile/__base-layout/cards/'
      path: '/cards'
      fullPath: '/mobile/cards'
      preLoaderRoute: typeof Mobile_baseLayoutCardsIndexRouteImport
      parentRoute: typeof Mobile_baseLayoutRoute
    }
    '/desktop/__app/withdraw/': {
      id: '/desktop/__app/withdraw/'
      path: '/withdraw'
      fullPath: '/desktop/withdraw'
      preLoaderRoute: typeof Desktop_appWithdrawIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/policies/': {
      id: '/desktop/__app/policies/'
      path: '/policies'
      fullPath: '/desktop/policies'
      preLoaderRoute: typeof Desktop_appPoliciesIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/my-cards/': {
      id: '/desktop/__app/my-cards/'
      path: '/my-cards'
      fullPath: '/desktop/my-cards'
      preLoaderRoute: typeof Desktop_appMyCardsIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/how-to-play/': {
      id: '/desktop/__app/how-to-play/'
      path: '/how-to-play'
      fullPath: '/desktop/how-to-play'
      preLoaderRoute: typeof Desktop_appHowToPlayIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/home/': {
      id: '/desktop/__app/home/'
      path: '/home'
      fullPath: '/desktop/home'
      preLoaderRoute: typeof Desktop_appHomeIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/game/': {
      id: '/desktop/__app/game/'
      path: '/game'
      fullPath: '/desktop/game'
      preLoaderRoute: typeof Desktop_appGameIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/desktop/__app/buy/': {
      id: '/desktop/__app/buy/'
      path: '/buy'
      fullPath: '/desktop/buy'
      preLoaderRoute: typeof Desktop_appBuyIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
    '/mobile/__base-layout/card/$cardId/': {
      id: '/mobile/__base-layout/card/$cardId/'
      path: '/card/$cardId'
      fullPath: '/mobile/card/$cardId'
      preLoaderRoute: typeof Mobile_baseLayoutCardCardIdIndexRouteImport
      parentRoute: typeof Mobile_baseLayoutRoute
    }
    '/desktop/__app/my-cards/$card/': {
      id: '/desktop/__app/my-cards/$card/'
      path: '/my-cards/$card'
      fullPath: '/desktop/my-cards/$card'
      preLoaderRoute: typeof Desktop_appMyCardsCardIndexRouteImport
      parentRoute: typeof Desktop_appRoute
    }
  }
}

interface Desktop_appRouteChildren {
  Desktop_appBuyIndexRoute: typeof Desktop_appBuyIndexRoute
  Desktop_appGameIndexRoute: typeof Desktop_appGameIndexRoute
  Desktop_appHomeIndexRoute: typeof Desktop_appHomeIndexRoute
  Desktop_appHowToPlayIndexRoute: typeof Desktop_appHowToPlayIndexRoute
  Desktop_appMyCardsIndexRoute: typeof Desktop_appMyCardsIndexRoute
  Desktop_appPoliciesIndexRoute: typeof Desktop_appPoliciesIndexRoute
  Desktop_appWithdrawIndexRoute: typeof Desktop_appWithdrawIndexRoute
  Desktop_appMyCardsCardIndexRoute: typeof Desktop_appMyCardsCardIndexRoute
}

const Desktop_appRouteChildren: Desktop_appRouteChildren = {
  Desktop_appBuyIndexRoute: Desktop_appBuyIndexRoute,
  Desktop_appGameIndexRoute: Desktop_appGameIndexRoute,
  Desktop_appHomeIndexRoute: Desktop_appHomeIndexRoute,
  Desktop_appHowToPlayIndexRoute: Desktop_appHowToPlayIndexRoute,
  Desktop_appMyCardsIndexRoute: Desktop_appMyCardsIndexRoute,
  Desktop_appPoliciesIndexRoute: Desktop_appPoliciesIndexRoute,
  Desktop_appWithdrawIndexRoute: Desktop_appWithdrawIndexRoute,
  Desktop_appMyCardsCardIndexRoute: Desktop_appMyCardsCardIndexRoute,
}

const Desktop_appRouteWithChildren = Desktop_appRoute._addFileChildren(
  Desktop_appRouteChildren,
)

interface DesktopRouteChildren {
  Desktop_appRoute: typeof Desktop_appRouteWithChildren
  DesktopIndexRoute: typeof DesktopIndexRoute
}

const DesktopRouteChildren: DesktopRouteChildren = {
  Desktop_appRoute: Desktop_appRouteWithChildren,
  DesktopIndexRoute: DesktopIndexRoute,
}

const DesktopRouteWithChildren =
  DesktopRoute._addFileChildren(DesktopRouteChildren)

interface Mobile_baseLayoutRouteChildren {
  Mobile_baseLayoutCardsIndexRoute: typeof Mobile_baseLayoutCardsIndexRoute
  Mobile_baseLayoutExtractionsIndexRoute: typeof Mobile_baseLayoutExtractionsIndexRoute
  Mobile_baseLayoutPoliciesIndexRoute: typeof Mobile_baseLayoutPoliciesIndexRoute
  Mobile_baseLayoutWithdrawIndexRoute: typeof Mobile_baseLayoutWithdrawIndexRoute
  Mobile_baseLayoutCardCardIdIndexRoute: typeof Mobile_baseLayoutCardCardIdIndexRoute
}

const Mobile_baseLayoutRouteChildren: Mobile_baseLayoutRouteChildren = {
  Mobile_baseLayoutCardsIndexRoute: Mobile_baseLayoutCardsIndexRoute,
  Mobile_baseLayoutExtractionsIndexRoute:
    Mobile_baseLayoutExtractionsIndexRoute,
  Mobile_baseLayoutPoliciesIndexRoute: Mobile_baseLayoutPoliciesIndexRoute,
  Mobile_baseLayoutWithdrawIndexRoute: Mobile_baseLayoutWithdrawIndexRoute,
  Mobile_baseLayoutCardCardIdIndexRoute: Mobile_baseLayoutCardCardIdIndexRoute,
}

const Mobile_baseLayoutRouteWithChildren =
  Mobile_baseLayoutRoute._addFileChildren(Mobile_baseLayoutRouteChildren)

interface MobileRouteChildren {
  Mobile_baseLayoutRoute: typeof Mobile_baseLayoutRouteWithChildren
  MobileIndexRoute: typeof MobileIndexRoute
  MobileBuyCardsIndexRoute: typeof MobileBuyCardsIndexRoute
  MobileGameIndexRoute: typeof MobileGameIndexRoute
  MobileHomeIndexRoute: typeof MobileHomeIndexRoute
  MobileProfileIndexRoute: typeof MobileProfileIndexRoute
}

const MobileRouteChildren: MobileRouteChildren = {
  Mobile_baseLayoutRoute: Mobile_baseLayoutRouteWithChildren,
  MobileIndexRoute: MobileIndexRoute,
  MobileBuyCardsIndexRoute: MobileBuyCardsIndexRoute,
  MobileGameIndexRoute: MobileGameIndexRoute,
  MobileHomeIndexRoute: MobileHomeIndexRoute,
  MobileProfileIndexRoute: MobileProfileIndexRoute,
}

const MobileRouteWithChildren =
  MobileRoute._addFileChildren(MobileRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DesktopRoute: DesktopRouteWithChildren,
  MobileRoute: MobileRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
